// extracted by mini-css-extract-plugin
export var container = "_48-0";
export var containerTopRight = "_48-1";